import React, { useState, useEffect } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import AssetModalWrapper from './AssetModal.styles';
import { Form, Input, Button, Select, Row, Col, DatePicker, InputNumber, Tabs, Upload, Switch, Radio } from 'antd';
import Loader from '@iso/components/utility/loader';
import { useSelector } from 'react-redux';
import { assetService, activityService } from '@iso/services';
import moment from 'moment';
import _ from 'lodash';
import { dateHelper } from '@iso/lib/helpers/dateHelper';
import L from 'leaflet';
import inside from 'point-in-polygon';
import { assetCategories } from '@iso/constants/assetCategories';
import { tankStorageTypes } from '@iso/constants/storageTypes';
import { assetStates } from '@iso/constants/assetStates';
import AddAssetHistoryModal from './AddAssetHistoryModal';
import AssetHistory from './AssetHistory';
import styled from "styled-components";
import SensorTab from './SensorTab';
import { UploadOutlined } from '@ant-design/icons';
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import FormTab from './FormTab';

const { Option } = Select;
const { TabPane } = Tabs;

const EditStorageModal = (props) => {
  const [form] = Form.useForm();
  const [addHistoryForm] = Form.useForm();
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [assetData, setAssetData] = useState({});
  const [assetHistory, setAssetHistory] = useState([]);
  const [visibleHistory, setVisibleHistory] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const activePermission = useSelector((state) => state.permission.activePermission);

  const updateDataAssetHistory = React.useCallback((asset_id, modal_type) => {
      activityService.getList(asset_id, modal_type).then(res => {
        if(res.code === '0000'){
          setAssetHistory(res.activities.reverse());
        }
      });
  }, [assetHistory]);
  
  useEffect(() => {
    setAssetData(props.dataAsset);
  }, [props.dataAsset]);

  const getRandomLatLng = (coordinates) => {
    var polygon = L.polygon([coordinates]);
    var bounds = polygon.getBounds();
    var x_max = bounds.getEast();
    var x_min = bounds.getWest();
    var y_max = bounds.getSouth();
    var y_min = bounds.getNorth();
    var lat=0, lng = 0;
    var count = 0;
    var area = polygon.getLatLngs()[0].map(function(point){
      return [point.lat, point.lng]            
    });

    while(!inside([lat, lng], area)){
      lat = y_min + (Math.random() * (y_max - y_min));
      lng = x_min + (Math.random() * (x_max - x_min));
      count+=1;
      if(count==100){
        break;
      }      
    }            

    return new L.LatLng(lat, lng);
  }
  
  const cancelModal = () => {
    props.onCancel();
    setLoading(false);
    form.resetFields();
  }

  const handleSubmit = (e) => {
    setLoading(true);

    form
      .validateFields()
      .then(values => {
        onStore(values);
      })
      .catch(info => {
        setLoading(false);
      });
  }

  const onStore = (values) => {
    const selectedObject = _.find(props.primaryObjects, (object) => {
      return object.id === values.asset.primary_object_id;
    });

    let point = assetData.point || null;
    if (selectedObject && (!assetData.id || assetData.primary_object_id != selectedObject.id)) {
      point = getRandomLatLng(selectedObject.area);
    }

    const data = {
      facility: {
        ...values.asset,
        date_of_purchase: values.asset.date_of_purchase ? dateHelper.dateForAPI(values.asset.date_of_purchase) : '',
        manufacture_date: values.asset.manufacture_date ? dateHelper.dateForAPI(values.asset.manufacture_date) : '',
        point,
        available_to_contractor: values.asset.available_to_contractor ? 1 : 0,
        property_id: props.propertyId,
      }
    }

    assetService.storeOrUpdate(data, assetData.id).then(res => {
      if(res.code === '0000'){
        props.onSaved(res.facility);
        if (props.updateDataAssets) {
          props.updateDataAssets();
        }
        cancelModal();
        form.resetFields();
      } else {
        setLoading(false);
      }
    });
  }

  useEffect(() => {
    setFields([
      {
        name: ['asset', 'title'],
        value: assetData.title || '',
      },
      {
        name: ['asset', 'available_to_contractor'],
        value: !!assetData.available_to_contractor,
      },
      {
        name: ['asset', 'category'],
        value: assetData.category,
      },
      {
        name: ['asset', 'type'],
        value: assetData.type,
      },
      {
        name: ['asset', 'state'],
        value: assetData.state,
      },
      {
        name: ['asset', 'other_state'],
        value: assetData.other_state,
      },
      {
        name: ['asset', 'date_of_purchase'],
        value: assetData.date_of_purchase ? moment(assetData.date_of_purchase) : '',
      },
      {
        name: ['asset', 'manufacture_date'],
        value: assetData.manufacture_date ? moment(assetData.manufacture_date) : '',
      },
      {
        name: ['asset', 'description'],
        value: assetData.description || '',
      },
      {
        name: ['asset', 'primary_object_id'],
        value: assetData.primary_object_id || '',
      },
      {
        name: ['asset', 'height_at_100'],
        value: assetData.height_at_100 ? Number(assetData.height_at_100) : '',
      },
      {
        name: ['asset', 'litres_at_100'],
        value: assetData.litres_at_100 ? Number(assetData.litres_at_100) : '',
      },
      {
        name: ['asset', 'height_at_0'],
        value: assetData.height_at_0 ? Number(assetData.height_at_0) : '',
      },
      {
        name: ['asset', 'litres_at_0'],
        value: assetData.litres_at_0 ? Number(assetData.litres_at_0) : '',
      },
      {
        name: ['asset', 'measurement_direction'],
        value: assetData.measurement_direction || 'top_to_bottom',
      },

    ]);
  }, [props.propertyId, props.visible, assetData]);

  const renderOptionsAssetCategory = () => {
    let options = [];
    _.forEach(assetCategories, (cat, index) => {
      options.push(
        <Option key={index} value={cat.value}>
          <div>{cat.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a category"
        allowClear
        size="large"
        disabled
      >
        {options}
      </Select>
    );
  }

  const renderOptionsStorageType = () => {
    let options = [];
    _.forEach(tankStorageTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a storage type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsAssetState = () => {
    let options = [];
    _.forEach(assetStates, (state, index) => {
      options.push(
        <Option key={index} value={state.value}>
          <ColorItemRow>
            <ColorItemPreview style={{backgroundColor: state.color}}></ColorItemPreview>
            <div>{state.label}</div>
          </ColorItemRow>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a state"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionObject = (objects) => {
    let options = [];
    _.forEach(objects, (object, index) => {
      options.push(
        <Option key={object.id} value={object.id}>
          {object.name}
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select an object"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const [activeTab, setActiveTab] = useState("1");
  const onChangeTab = (key) => {
    setActiveTab(key);
  }

  const addHistory = (object, e) => {
    setVisibleHistory(true);
  }

  const cancelModalHistory = () => {
    addHistoryForm.resetFields();
    setVisibleHistory(false);
    setLoadingHistory(false);
  }

  return(
    <>
    <AssetModalWrapper
      visible={props.visible}
      onCancel={cancelModal}
      maskClosable={false}
      title={props.dataAsset && props.dataAsset.id ? <IntlMessages id="propertyPage.modal.asset.editAsset"/> : <IntlMessages id="propertyPage.modal.asset.addAsset"/>}
      footer={[
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
    {
        modalLoading ?
        <Loader /> : 
        <Tabs defaultActiveKey="1" className="form-body" onChange={onChangeTab}>
        <TabPane tab={<IntlMessages id="propertyPage.mobModal.detailTab" />} key="1"> 
          <Form
            form={form}
            layout="vertical"
            scrollToFirstError
            fields={fields}
            id="#1"
          >
          <div>
            <Form.Item
              name={['asset', 'available_to_contractor']}
              className="isoInputWrapper"
              label="Available to contractors"
              valuePropName="checked"
            >
              <Switch checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>
            
            <Form.Item
              name={['asset', 'title']}
              className="isoInputWrapper"
              label="Title"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                  whitespace: true,
                },
                {
                  max:255,
                  message: 'Title must be maximum 255 characters.'
                },
              ]}
            >
              <Input size="large" placeholder="Input asset title"/>
            </Form.Item>
            
            <Form.Item
              name={['asset', 'category']}
              className="isoInputWrapper"
              label="Category"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionsAssetCategory()}
            </Form.Item>
            
            <Form.Item
              name={['asset', 'type']}
              className="isoInputWrapper"
              label="Storage Type"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionsStorageType()}
            </Form.Item>

            <Form.Item
              name={['asset', 'primary_object_id']}
              className="isoInputWrapper"
              label="Location"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionObject(props.primaryObjects)}
            </Form.Item>

            <div style={{ background: '#f5f5f5', padding: '16px', borderRadius: '4px', marginBottom: '16px' }}>
            <h4 style={{ marginTop: 0 }}>Tank Capacity Configuration</h4>
            
            <Form.Item
              name={['asset', 'measurement_direction']}
              label="Sensor Measurement Direction"
              rules={[{ required: true, message: 'Please select measurement direction' }]}
            >
              <Radio.Group>
                <Radio value="bottom_to_top">
                  <span>Bottom → Top</span>
                  <div style={{ fontSize: '12px', color: '#666', marginLeft: '24px' }}>
                    (Sensor measures upwards from bottom - height increases as tank fills)
                  </div>
                </Radio>
                <Radio value="top_to_bottom" style={{ marginTop: '8px' }}>
                  <span>Top → Bottom</span>
                  <div style={{ fontSize: '12px', color: '#666', marginLeft: '24px' }}>
                    (Sensor measures downwards from top - height decreases as tank fills)
                  </div>
                </Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return prevValues?.asset?.measurement_direction !== currentValues?.asset?.measurement_direction;
              }}
            >
              {({ getFieldValue }) => {
                const direction = getFieldValue(['asset', 'measurement_direction']) || assetData.measurement_direction || 'top_to_bottom';
                const isBottomToTop = direction === 'bottom_to_top';
                
                return (
                  <>
                    <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px', marginTop: '16px' }}>
                      {isBottomToTop 
                        ? 'Configure sensor measurements from bottom of tank. Height increases as tank fills.'
                        : 'Configure sensor measurements from top of tank. Height decreases as tank fills.'
                      }
                    </p>

                    <Row gutter={16}>
                      <Col xs={24} md={11}>
                        <div style={{ marginBottom: '16px' }}>
                          <h5 style={{ marginBottom: '8px' }}>At 100% (Full Tank)</h5>
                          <Form.Item
                            name={['asset', 'height_at_100']}
                            label="Height (mm)"
                            rules={[
                              { required: true, message: 'Required' },
                              { type: 'number', min: 0, message: 'Must be 0 or greater' },
                            ]}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              size="large"
                              placeholder={isBottomToTop ? "e.g., 2500mm" : "e.g., 10mm"}
                              min={0}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['asset', 'litres_at_100']}
                            label="Volume (Litres)"
                            rules={[
                              { required: true, message: 'Required' },
                              { type: 'number', min: 0, message: 'Must be 0 or greater' },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const litresAt0 = getFieldValue(['asset', 'litres_at_0']);
                                  if (value === undefined || value === null || value === '') return Promise.resolve();
                                  if (litresAt0 === undefined || litresAt0 === null || litresAt0 === '') {
                                    return Promise.resolve();
                                  }
                                  if (Number(value) > Number(litresAt0)) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(new Error('Volume at 100% must be greater than volume at 0%'));
                                },
                              }),
                            ]}
                            dependencies={[['asset', 'litres_at_0']]}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              size="large"
                              placeholder="e.g., 10000L"
                              min={0}
                            />
                          </Form.Item>
                        </div>
                      </Col>

                      <Col xs={0} md={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'stretch' }}>
                        <div style={{ 
                          width: '1px', 
                          backgroundColor: '#d9d9d9',
                          margin: '0 auto'
                        }} />
                      </Col>

                      <Col xs={24} md={11}>
                        <div style={{ marginBottom: '16px' }}>
                          <h5 style={{ marginBottom: '8px' }}>At 0% (Empty Tank)</h5>
                          <Form.Item
                            name={['asset', 'height_at_0']}
                            label="Height (mm)"
                            rules={[
                              { required: true, message: 'Required' },
                              { type: 'number', min: 0, message: 'Must be 0 or greater' },
                            ]}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              size="large"
                              placeholder={isBottomToTop ? "e.g., 50mm" : "e.g., 2500mm"}
                              min={0}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['asset', 'litres_at_0']}
                            label="Volume (Litres)"
                            rules={[
                              { required: true, message: 'Required' },
                              { type: 'number', min: 0, message: 'Must be 0 or greater' },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const litresAt100 = getFieldValue(['asset', 'litres_at_100']);
                                  
                                  if (value === undefined || value === null || value === '') return Promise.resolve();
                                  if (litresAt100 === undefined || litresAt100 === null || litresAt100 === '') {
                                    return Promise.resolve();
                                  }
                                  if (Number(value) < Number(litresAt100)) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(new Error('Volume at 0% must be less than volume at 100%'));
                                },
                              }),
                            ]}
                            dependencies={[['asset', 'litres_at_100']]}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              size="large"
                              placeholder="e.g., 0L"
                              min={0}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </>
                );
              }}
            </Form.Item>
          </div>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name={['asset', 'state']}
                  className="isoInputWrapper"
                  label="State"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  {renderOptionsAssetState()}
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={['asset', 'date_of_purchase']}
                  className="isoInputWrapper"
                  label="Date Of Purchase"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  <DatePicker size="large" style={{width: '100%'}} />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return (prevValues['asset'] && (prevValues['asset'].state !== currentValues['asset'].state));
              }}
            >
              {({ getFieldValue }) => {
                  if(getFieldValue('asset')){
                    if (getFieldValue('asset').state === "other"){
                      return (
                        <Form.Item
                          name={['asset', 'other_state']}
                          className="isoInputWrapper"
                          label="Other State"
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                          ]}
                        >
                          <Input size="large" placeholder="Input other state"/>
                        </Form.Item>
                      );
                    }
                  } else {
                    if (assetData.state === "other"){
                      return (
                        <Form.Item
                          name={['asset', 'other_state']}
                          className="isoInputWrapper"
                          label="Other State"
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                          ]}
                        >
                          <Input size="large" placeholder="Input other state"/>
                        </Form.Item>
                      );
                    }
                  }
                }
              }
            </Form.Item>

            <Form.Item
              name={['asset', 'manufacture_date']}
              className="isoInputWrapper"
              label="Manufacture Date"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              <DatePicker size="large" style={{width: '100%'}} />
            </Form.Item>

            <Form.Item
              name={['asset', 'description']}
              className="isoInputWrapper"
              label="Description"
            >
              <Input.TextArea />
            </Form.Item>
          </div>  
      </Form>
      </TabPane>
      <TabPane tab={<IntlMessages id="propertyPage.mobModal.historyTab" />} key="2">
        <Row>
          <Col xs={{span: 7}} md={{span: 7}}>
            {(activePermission == "owner" || activePermission == "admin" || activePermission == "modify") &&
            <Button key="submit" className="btn-create-breed" type="primary" onClick={addHistory}>
              {<IntlMessages id="propertyPage.mobModal.historyTab.addHistory" />}
            </Button>}
          </Col>
          <Col xs={{span: 15}} md={{span: 17}}>
          </Col>
        </Row>
        <br/>
        <AssetHistory assetHistory={assetHistory} updateDataAssetHistory={updateDataAssetHistory} dataId={assetData.id}/>
        <AddAssetHistoryModal        
          visibleHistory={visibleHistory} 
          cancelModal={cancelModalHistory}
          primaryObjects={props.primaryObjects}
          model='facilities'
          dataId={assetData.id}
          propertyId={props.propertyId}
          updateDataAssetHistory={updateDataAssetHistory}
        />
      </TabPane>
      <TabPane
        tab={<IntlMessages id="propertyPage.mobModal.sensorTab" />}
        key="3"
      >
        <SensorTab assetId={assetData.id} propertyId={props.propertyId} />
      </TabPane>
      <TabPane
        tab={<IntlMessages id="propertyPage.mobModal.formTab" />}
        key="4"
      >
        <FormTab assetId={assetData.id} propertyId={props.propertyId} />
      </TabPane>
      </Tabs>
      }     
    </AssetModalWrapper>
    </>
  )
}

export default EditStorageModal;

const ColorItemRow = styled.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  div{
    margin: 4px;
  }
`;

const ColorItemPreview = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 2px;
`